realmCommerceApp.controller("OrderDetailsController", OrderDetailsController);

/*@ngInject*/
function OrderDetailsController($uibModal, order) {
    var vm = this;
    vm.order = null;
    vm.promptOrderMessage = promptOrderMessage;
    vm.itemShipmentDetails = itemShipmentDetails;
    vm.orderShipmentStatusFilter = orderShipmentStatusFilter;

    activate();

    function activate() {
        vm.order = order;
    }

    function promptOrderMessage() {
        $uibModal.open({
            template: require('../layout/modal/orderHelpDesk.modal.html'),
            controller: 'OrderController',
            controllerAs: 'vm',
            resolve: {
                orderModel: () => vm.order
            }
        });
    }

    function itemShipmentDetails(itemNumber) {
        let result = "No status";
        if (vm.order.shipments != null) {
            var order = vm.order;
            order.shipments.forEach(function (shipment) {
                shipment.shipmentItems.forEach(function (shipmentItem) {
                    if (shipmentItem.itemNumber == itemNumber) {
                        result = shipmentItem;
                    }
                })
            });
        }
        return result;
    }

    function orderShipmentStatusFilter(order) {
        let result = true;
        if (order.shipments != null) {
            var order = order;
            order.shipments.forEach(function (shipment) {
                shipment.shipmentItems.forEach(function (shipmentItem) {
                    if (shipmentItem.status != 'Delivered') {
                        result = false;
                    }
                });
            });
        }
        return result;
    }
}






// WEBPACK FOOTER //
// ./static/js/app/order/order.details.controller.js